import { render, staticRenderFns } from "./CookieIframe.vue?vue&type=template&id=1772311c&"
import script from "./CookieIframe.vue?vue&type=script&lang=js&"
export * from "./CookieIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports